import React, { Component } from "react";
import * as s from "./MultiSelectDropdown.module.scss";
import { Icons } from "src/libs/assets";
import { FilterChip } from "src/views/shared/components";
import { observer } from "mobx-react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  inputPlaceholder: {
    hasSelectedValues: string;
    noSelectedValues: string;
    allValuesSelected?: string;
  };
  options: { value: string; selected: boolean; id?: number }[];
  selectedOptions?: { value: string }[];
  onOptionClick?: any;
  disabled?: boolean;
  onOpen?: () => any;
}

interface State {
  dropdownOpen: boolean;
  searching: boolean;
  searchResults: any;
  hasBeenClicked: boolean;
}

@observer
export class MultiSelectDropdown extends Component<Props, State> {
  private inputRef;

  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      searching: false,
      searchResults: [],
      hasBeenClicked: false,
    };
    this.inputRef = React.createRef();
  }

  renderSelectedValue = (item, key) => {
    const { options, onOptionClick, disabled } = this.props;
    const { value } = item;

    return (
      <FilterChip
        key={key}
        className={s.selectedLabel}
        title={value}
        small
        selected
        hideIcon={disabled}
        onClick={disabled ? null : () => onOptionClick(options, item)}
      />
    );
  };

  renderDropdownLabel = (item, key) => {
    const { options, onOptionClick } = this.props;
    const { value } = item;
    return (
      <div
        key={key}
        className={s.dropdownItem}
        onClick={() => onOptionClick(options, item)}
      >
        {value}
      </div>
    );
  };

  toggleDropdown = () => {
    const { disabled, onOpen } = this.props;
    if (disabled) {
      // don't open dropdown if disabled
      return;
    }
    const { dropdownOpen } = this.state;
    if (dropdownOpen) {
      this.setState({ dropdownOpen: false, searching: false });
    } else {
      this.setState({ dropdownOpen: true, hasBeenClicked: true });
      onOpen?.();
    }
  };

  openDropdown = () => {
    const { disabled, onOpen } = this.props;
    if (disabled) {
      // don't open dropdown if disabled
      return;
    }
    this.setState({ dropdownOpen: true, hasBeenClicked: true });
    onOpen?.();
  };

  closeDropdown = () => {
    const { disabled } = this.props;
    if (disabled) {
      // don't open dropdown if disabled
      return;
    }
    this.setState({ dropdownOpen: false, searching: false });
  };

  searchDropdown = (e) => {
    const options = this.props;
    const query = e.target.value.toLowerCase();
    let results = options.options?.filter((obj) =>
      obj.value?.toLowerCase().includes(query)
    );

    this.setState({
      searching: true,
      searchResults: results,
    });
  };

  render() {
    const {
      options = [],
      selectedOptions,
      inputPlaceholder,
      className,
      disabled,
    } = this.props;
    const {
      dropdownOpen,
      searching,
      searchResults,
      hasBeenClicked,
    } = this.state;
    const {
      hasSelectedValues,
      noSelectedValues,
      allValuesSelected,
    } = inputPlaceholder;

    const multiSelectDropdownClasses = [s.multiSelectDropdownContainer];
    const dropdownClasses = [s.multiSelectDropdown];
    const multiSelectInputLabelClasses = [s.multiSelectInputLabel];
    const searchInputFieldClasses = [s.searchInputField];

    if (className) multiSelectDropdownClasses.push(className);
    if (dropdownOpen) dropdownClasses.push(s.open);

    let inputPlaceholderText = " ";

    const hasSelected =
      selectedOptions?.length > 0 || options.some((item) => item.selected);
    const selectedValues =
      selectedOptions || options.filter((item) => item.selected);

    if (hasBeenClicked || hasSelected) {
      multiSelectInputLabelClasses.push(s.hasBeenClicked);
      searchInputFieldClasses.push(s.hasBeenClicked);

      if (hasSelected) {
        inputPlaceholderText =
          selectedValues.length === options.length
            ? allValuesSelected
            : hasSelectedValues;
      } else {
        inputPlaceholderText = noSelectedValues;
      }
    }

    return (
      <div className={multiSelectDropdownClasses.join(" ")}>
        <div className={s.inputContainer}>
          <div
            className={s.selectedValuesContainer}
            onClick={this.closeDropdown}
          >
            {selectedValues && selectedValues.map(this.renderSelectedValue)}
          </div>
          <label
            htmlFor={inputPlaceholderText}
            className={multiSelectInputLabelClasses.join(" ")}
          >
            {noSelectedValues}
          </label>
          {!disabled && (
            <input
              type="text"
              className={searchInputFieldClasses.join(" ")}
              placeholder={inputPlaceholderText}
              ref={this.inputRef}
              onFocus={this.openDropdown}
              onInput={this.searchDropdown}
            />
          )}
          <img
            src={Icons.dropdown_small}
            alt="dropdown-icon"
            className={s.dropdownIcon}
            onClick={this.toggleDropdown}
          />
        </div>
        <div className={dropdownClasses.join(" ")}>
          {searching &&
            searchResults &&
            searchResults
              .filter((item) => !item.selected)
              .map(this.renderDropdownLabel)}
          {!searching &&
            options &&
            options
              .filter((item) => !item.selected)
              .map(this.renderDropdownLabel)}
          {!searching &&
            options &&
            options.filter((item) => item.selected).length ===
              options.length && (
              <div className={s.noResultsItem}>{allValuesSelected}</div>
            )}
          {!searching && options && options.length === 0 && (
            <div className={s.noResultsItem}>No entries found.</div>
          )}
          {searching && (!searchResults || searchResults.length === 0) && (
            <div className={s.noResultsItem}>No results found.</div>
          )}
        </div>
      </div>
    );
  }
}
